import React from 'react';
import { Route } from 'react-router-dom';

interface Props {
    layout: any,
    component: any,
    rest?: any,
    exact?: any,
    path: string
}
export default function RouteWithLayout(props: Props) {
    return(
        <Route {...props.rest} render={(_props: any) => 
            React.createElement(props.layout, _props, React.createElement(props.component, props))
        } />
    )
}